"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var core_1 = require("@material-ui/core");
var AuthStore = __importStar(require("../../../app/store/AuthStore"));
var ProgramStore = __importStar(require("../../../app/store/ProgramStore"));
var Auth_1 = __importStar(require("../../../youwell-common/Auth"));
var urls_1 = __importDefault(require("../../../app/urls"));
var apiUrls_1 = __importDefault(require("../../../youwell-common/apiUrls"));
var constants_1 = require("./constants");
var constants_2 = require("../../../youwell-common/constants");
var arrayUtils_1 = require("../../../youwell-common/arrayUtils");
var dateUtils_1 = require("../../../youwell-common/dateUtils");
var store_1 = require("../../../app/store");
var translate_1 = __importDefault(require("../../../app/localization/translate"));
var externalUserService_1 = require("../../../app/services/externalUserService");
var TABS = __assign(__assign({}, constants_2.loginTypes), { serverLogin: 'serverlogin' });
var useStyles = (0, core_1.makeStyles)(function (theme) {
    var _a;
    return ({
        root: {},
        tab: {
            minWidth: 80,
        },
        login_container: (_a = {
                padding: theme.spacing(2, 4, 0)
            },
            _a[constants_1.heightBreak] = {
                padding: theme.spacing(4),
            },
            _a[theme.breakpoints.down('xs')] = {
                padding: theme.spacing(2),
            },
            _a),
        loginHeader: {},
        loginBox: {
            margin: theme.spacing(2, 0),
            position: 'relative',
        },
        loginDescription: {
            color: theme.palette.grey[700],
            marginTop: theme.spacing(3),
            marginBottom: theme.spacing(3),
        },
        textField: {
            marginBottom: theme.spacing(3),
            background: theme.palette.grey[50],
        },
        loginButton: {
            marginTop: theme.spacing(4),
            padding: theme.spacing(1),
        },
        forgotPassword: {
            marginTop: theme.spacing(1),
            marginRight: theme.spacing(1),
        },
        loading: {
            position: 'absolute',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, 0)',
        },
        infoContainer: {
            marginTop: theme.spacing(4),
            color: theme.youwell.colors.secondary,
        },
        backLinkContainer: {
            marginTop: theme.spacing(6),
            display: 'flex',
            justifyContent: 'flex-end',
        },
        backLink: {
            textDecoration: 'underline',
        },
    });
}, { name: 'Login' });
var Login = function () {
    var _a, _b, _c;
    var classes = useStyles();
    var params = (0, react_router_dom_1.useParams)();
    var dispatch = (0, store_1.useYouwellDispatch)();
    var translate = (0, translate_1.default)();
    var loading = (0, store_1.useYouwellSelector)(function (state) { return state.auth.loading; });
    var errorMessage = (0, store_1.useYouwellSelector)(function (state) { return [].concat(state.auth.errors).filter(function (val) { return val; }).join('<br/>'); });
    var appConfig = (0, store_1.useYouwellSelector)(function (state) { return state.pageSettings.appConfig; });
    var logoutReason = (0, store_1.useYouwellSelector)(function (state) { return state.auth.logoutReason; });
    var redirect = params.redirect ? decodeURIComponent(params.redirect) : urls_1.default.inside.home;
    var externalRouteMatch = (0, react_router_dom_1.useRouteMatch)("".concat(urls_1.default.login, "/").concat(urls_1.default.loginParts.external));
    var _d = React.useState(''), email = _d[0], setEmail = _d[1];
    var _e = React.useState(''), password = _e[0], setPassword = _e[1];
    var _f = React.useState((_b = (_a = appConfig === null || appConfig === void 0 ? void 0 : appConfig.allowedLogins) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : TABS.password), tab = _f[0], setTab = _f[1];
    var _g = React.useState(false), isLoggingIn = _g[0], setIsLoggingIn = _g[1];
    var login = function () {
        setIsLoggingIn(true);
        dispatch(AuthStore.actionCreators.login({
            email: email,
            password: password,
            orgId: appConfig === null || appConfig === void 0 ? void 0 : appConfig.orgId,
        }, { redirect: redirect }));
    };
    var startNewSession = function () {
        setIsLoggingIn(true);
        dispatch(AuthStore.actionCreators.startNewSession({
            orgId: appConfig.orgId,
            programId: appConfig.startProgramId,
            programStartDate: (0, dateUtils_1.today)(),
        }, { redirect: redirect }));
    };
    var allowedLogins = (0, arrayUtils_1.toBoolLookup)(appConfig.allowedLogins);
    var isLoggedIn = Auth_1.default.isUserAuthenticated();
    React.useEffect(function () {
        if (isLoggingIn) {
            return;
        }
        if (params.accessKey) {
            setIsLoggingIn(true);
            dispatch(AuthStore.actionCreators.loginWithAccessKey({
                key: params.accessKey,
                orgId: appConfig === null || appConfig === void 0 ? void 0 : appConfig.orgId,
            }, { redirect: redirect }));
        }
        else if (params.code) {
            setIsLoggingIn(true);
            var loginState = {
                code: params.code,
                provider: params.provider,
                state: params.state,
                orgId: appConfig === null || appConfig === void 0 ? void 0 : appConfig.orgId,
                appParameters: params.appParameters,
                day: (0, dateUtils_1.today)(),
            };
            if (params.appParameters === 'ext') {
                (0, externalUserService_1.loginExternalUser)(dispatch, loginState, { redirect: redirect });
            }
            else {
                dispatch(AuthStore.actionCreators.loginWithCode(loginState, { redirect: redirect }));
            }
        }
        else if (isLoggedIn) {
            var loggedInType = Auth_1.default.getLoginType();
            switch (loggedInType) {
                case Auth_1.authTypes.user: {
                    setIsLoggingIn(true);
                    dispatch(AuthStore.actionCreators.getUserProfile({ redirect: redirect }));
                    break;
                }
                case Auth_1.authTypes.external: {
                    var extRedirect = params.redirect && params.redirect.startsWith(urls_1.default.external.home) ? decodeURIComponent(params.redirect) : urls_1.default.external.home;
                    dispatch(ProgramStore.actionCreators.redirect(extRedirect));
                    break;
                }
                case Auth_1.authTypes.orgSelect: {
                    dispatch(ProgramStore.actionCreators.redirect("".concat(urls_1.default.login, "/").concat(urls_1.default.loginParts.selectOrg)));
                    break;
                }
                case Auth_1.authTypes.public:
                default: {
                    dispatch(AuthStore.actionCreators.logout(constants_2.logoutReasons.invalidState));
                }
            }
        }
    }, [appConfig === null || appConfig === void 0 ? void 0 : appConfig.orgId, dispatch, isLoggedIn, isLoggingIn, params, params.accessKey, params.code, params.provider, params.state, redirect]);
    var onEnter = function (action) { return function (e) {
        if (e.key === 'Enter' && email && password) {
            action();
        }
    }; };
    var appLoginParameters = externalRouteMatch ? '?appParameters=ext' : '';
    var currentTab = isLoggedIn || params.code || params.accessKey ? TABS.serverLogin : tab;
    var hasMultipleLoginOptions = ((_c = appConfig.allowedLogins) === null || _c === void 0 ? void 0 : _c.length) > 1;
    return (React.createElement("div", { className: classes.root },
        React.createElement("div", { className: classes.login_container },
            hasMultipleLoginOptions && currentTab !== TABS.serverLogin && (React.createElement(core_1.Tabs, { className: classes.tabs, value: currentTab, onChange: function (e, newTab) { return setTab(newTab); }, variant: "fullWidth" },
                allowedLogins[constants_2.loginTypes.password] && React.createElement(core_1.Tab, { classes: { root: classes.tab }, label: translate('email'), value: TABS.password }),
                allowedLogins[constants_2.loginTypes.idPorten] && React.createElement(core_1.Tab, { classes: { root: classes.tab }, label: "IDPorten", value: TABS.idPorten }),
                allowedLogins[constants_2.loginTypes.selfStart] && React.createElement(core_1.Tab, { classes: { root: classes.tab }, label: translate('start'), value: TABS.selfStart }))),
            React.createElement("div", { className: classes.loginBox },
                loading && (React.createElement("div", { className: classes.loading },
                    React.createElement(core_1.CircularProgress, null))),
                currentTab === TABS.password && (React.createElement(React.Fragment, null,
                    React.createElement(core_1.TextField, { id: "email", type: "email", className: classes.textField, value: email, onChange: function (e) { return setEmail(e.target.value); }, variant: "outlined", fullWidth: true, InputProps: {
                            onKeyPress: onEnter(login),
                            startAdornment: React.createElement(core_1.InputAdornment, { disablePointerEvents: true, position: "start" }, "".concat(translate('email'), ": ")),
                        } }),
                    React.createElement(core_1.TextField, { id: "password", type: "password", className: classes.textField, value: password, onChange: function (e) { return setPassword(e.target.value); }, variant: "outlined", fullWidth: true, InputProps: {
                            onKeyPress: onEnter(login),
                            startAdornment: React.createElement(core_1.InputAdornment, { disablePointerEvents: true, position: "start" }, "".concat(translate('password'), ": ")),
                        } }),
                    React.createElement(core_1.Button, { onClick: login, variant: "contained", fullWidth: true, color: "primary", className: classes.loginButton, disabled: loading }, translate('login.login')),
                    React.createElement(react_router_dom_1.Link, { to: "".concat(urls_1.default.login, "/").concat(urls_1.default.loginParts.forgotPassword) },
                        React.createElement(core_1.Typography, { variant: "body2", align: "right", className: classes.forgotPassword, display: "block" }, translate('login.forgotPassword'))))),
                currentTab === TABS.idPorten && (React.createElement(React.Fragment, null,
                    React.createElement(core_1.Typography, { color: "inherit", className: classes.loginDescription }, translate('login.idportenDescription', { appname: appConfig.appName })),
                    React.createElement(core_1.Button, { variant: "contained", fullWidth: true, color: "primary", className: classes.loginButton, href: "".concat(apiUrls_1.default.baseUrl, "/").concat(apiUrls_1.default.route.oauth, "/login/").concat(constants_2.IdProviders.idPorten, "/").concat(appLoginParameters), disabled: loading }, translate('login.loginWithIdporten')))),
                currentTab === TABS.selfStart && (React.createElement(React.Fragment, null,
                    React.createElement(core_1.Typography, { color: "inherit", className: classes.loginDescription }, translate('login.selfStartDescription', { appname: appConfig.appName })),
                    React.createElement(core_1.Button, { onClick: startNewSession, variant: "contained", fullWidth: true, color: "primary", className: classes.loginButton, disabled: loading }, translate('login.start')))),
                currentTab === TABS.serverLogin && (React.createElement(React.Fragment, null,
                    React.createElement(core_1.Typography, { color: "inherit", className: classes.loginDescription }, translate('login.loginInProgress')))),
                React.createElement("div", { className: classes.infoContainer },
                    logoutReason && (React.createElement(core_1.Typography, { color: "inherit", gutterBottom: true }, translate("errors.".concat(logoutReason), undefined, { onMissingTranslation: function () { return translate('login.youHaveBeenLoggedOut'); } }))),
                    errorMessage && (React.createElement(React.Fragment, null,
                        React.createElement(core_1.Typography, { color: "error", align: "center", display: "block" }, errorMessage === '1065' && currentTab === TABS.serverLogin
                            ? translate('login.serverLoginFailed')
                            : translate("errors.".concat(errorMessage), undefined, { onMissingTranslation: function () { return "System error (".concat(errorMessage, ")"); } })))),
                    currentTab === TABS.serverLogin && (React.createElement("div", { className: classes.backLinkContainer },
                        React.createElement("a", { href: urls_1.default.logout, className: classes.backLink }, translate('login.backToFrontPage')))))))));
};
exports.default = Login;
